import React, { useState, useEffect, useRef, useMemo, useCallback  } from 'react';
import { MapContainer, AttributionControl, useMap } from "react-leaflet";
//import MarkerClusterGroup from "react-leaflet-markercluster";
import { GestureHandling } from "leaflet-gesture-handling";

import { DynamicLayerControl } from '../map/layer-control'

import { generateIcon } from '../map/marker';

const shapes = {
  POINT: "Point",
  LINESTRING: "LineString",
  POLYGON: 'Polygon',
  MULTIPOINT: "MultiPoint",
  MULTILINESTRING: "MultiLineString",
  MULTIPOLYGON: "MultiPolygon",
  GEOMETRYCOLLECTION: "GeometryCollection"
};


const TopoCollection = ({ data, style }) => {
  const map = useMap();
  let zoom = null;
  
  map.eachLayer(function(layer) {
    if(layer.feature) {
      map.removeLayer(layer);
    }
  });


  
  const onEachFeature = (feature, layer) => {

    layer.bindPopup(feature.properties.popupContent);

    layer.bindTooltip(
      `<big>${feature.properties.mapCode || null}</big><p>${feature.properties.name}</p>`,
      {
          permanent:true,
          direction:'center',
          className: 'countryLabel'
      }
    );
  };


  let features = [];

  data.forEach(map => {
    features.push({
      type: 'Feature',
      geometry: map.geodata,
      style: { color: 'var(--map-chooser-tint, magenta)', weight: 2 },
      properties: {
        name: map.name,
        //type: map.type.toLowerCase(),
        path: map.path,
        mapCode: map.code,
        popupContent: `<h4><a href="${map.path}">${map.title}</a></h4>`,
      }
    })
  })

  let collection = {
    type: "FeatureCollection",
    features: []
  }


  const geojsonLayer = L.geoJson({
    type: "FeatureCollection",
    features
  }, {
    onEachFeature,
    style: (feature) => {
      return feature.style
    }
  }).addTo(map);

  const bounds = geojsonLayer.getBounds();
  if(bounds.isValid()) {
    map.fitBounds(bounds);
  }
}


const Map = ({ data, defaultCentre = [-41.2924, 174.7787], defaultZoom = 6, tint = null, defaultOverlay = 50, size }) => {
  const style = { color: tint || '#008f8a', weight: 2 }

  const ref = React.useRef();

  const threshold = size === 'md' ? 8 : 7;

  const displayMap = useMemo(
    () => (
      <MapContainer
        className={`markercluster-map size-${size}`}
        center={defaultCentre}
        zoom={defaultZoom}
        attributionControl={false}
        whenReady={({ target:map }) => {
          map.gestureHandling.enable();
          let zoom = map.getZoom();
          map.on('zoomend', (e) => {
  
            zoom = map.getZoom();
            if(zoom > threshold) {
              ref.current.classList.add('show-tooltips')
            }
            else {
              ref.current.classList.remove('show-tooltips')
            }
          })

          // a11y (?) move the controls above the map in the source order
          const mapPane = document.querySelector('.leaflet-map-pane');
          const controls = document.querySelector('.leaflet-control-container');
          mapPane.before(controls);
        }}
      >
        <DynamicLayerControl defaultOverlay={defaultOverlay} />

        <TopoCollection data={data} style={style} />
        <AttributionControl position="bottomright" prefix={false} />
      </MapContainer>
    ),
    [data],
  )


  return (
    <output 
      ref={ref}
      className='map-chooser__leaflet'
      //className={`${currentZoom > 8 ? 'show-tooltips' : ''}`}
      >
        {displayMap}
      
    </output>
  )
}

export default Map;
